import React, { useState, useContext } from "react";
import { useMutation } from "@apollo/client";
import { Form, Button, Header } from "semantic-ui-react";
import { UPDATE_USER_ATTRIBUTES } from "../../GraphQL";
import UserContext from "contexts/UserContext";
import PhoneInput from "components/PhoneInput";

const ProfileSettings = () => {
  const appUser = useContext(UserContext);

  const [updateUser] = useMutation(UPDATE_USER_ATTRIBUTES);

  const { name, phone_number, email } = appUser.getAttributes();
  const [form, setForm] = useState({ name, phone_number });

  const [saving, setSaving] = useState(false);
  const handleFormChange = (e, { name, value }) => {
    setForm({ ...form, [name]: value });
  };

  const phoneNumberInvalid =
    !form.phone_number || form.phone_number.length !== 12;
  const nameInvalid = !form.name || form.name.length === 0;

  const handleFormSubmit = () => {
    setSaving(true);
    updateUser({
      variables: { input: form },
      onCompleted: ({ editMyUser }) => {
        appUser.setAttributes(editMyUser);
        setSaving(false);
      },
    });
  };

  return (
    <Form onSubmit={handleFormSubmit}>
      <Header>My Profile</Header>
      <Form.Input
        fluid
        icon="mail"
        iconPosition="left"
        label="Email Address"
        name="email"
        value={email || ""}
        onChange={handleFormChange}
        disabled
      />
      <Form.Input
        fluid
        label="Name"
        name="name"
        error={nameInvalid}
        placeholder="John Doe"
        value={form.name || ""}
        onChange={handleFormChange}
      />
      <PhoneInput
        fluid
        icon="phone"
        type="tel"
        error={phoneNumberInvalid}
        iconPosition="left"
        placeholder="(512) 555-1212"
        label="Phone Number (USA Only)"
        name="phone_number"
        value={form.phone_number || ""}
        onChange={handleFormChange}
      />
      <Form.Field>
        <Button
          loading={saving}
          disabled={phoneNumberInvalid || nameInvalid}
          type="submit"
          basic
          primary
        >
          Save
        </Button>
        <Button
          type="button"
          basic
          onClick={() => setForm({ name, phone_number })}
        >
          Cancel
        </Button>
      </Form.Field>
    </Form>
  );
};

export default ProfileSettings;
